import TimeMe from 'timeme.js'
import axios from 'axios'

export default {
  init (pageName, idleTimeoutInSeconds) {
    TimeMe.initialize({
      currentPageName: pageName,
      idleTimeoutInSeconds: idleTimeoutInSeconds
    })

    TimeMe.callWhenUserLeaves(async () => {
      let time = TimeMe.getTimeOnCurrentPageInSeconds()
      if (!time) return

      TimeMe.resetAllRecordedPageTimes()
      try {
        await axios.patch(process.env.VUE_APP_URL_APP + '/b/time-track', {time: time}, { withCredentials: true })
      } catch (e) {
        console.error(e)
        return false
      }
    })
  },

  async force () {
    let time = TimeMe.getTimeOnCurrentPageInSeconds()
    if (!time) return

    TimeMe.resetAllRecordedPageTimes()
    TimeMe.startTimer()
    try {
      await axios.patch(process.env.VUE_APP_URL_APP + '/b/time-track', {time: time}, { withCredentials: true })
    } catch (e) {
      console.error(e)
      return false
    }
  }
}
